import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ContentWrapper = styled.div`
    display: flex;
    width: 100%;
    margin: auto;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    flex: 1;
	font-size: 20px;
    
  	@media(min-width: 1750px) {
		width: 1750px;
  	}
  	
	@media(min-width: 800px) {
    	font-size: 36px;
  	}
`;

const Content = ({ children }) => (
	<ContentWrapper>
		{children}
	</ContentWrapper>
);

Content.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Content;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/shoutboxvisualization/content.js